import React, { useEffect , useContext} from 'react';
import Context from '../../context/context';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function Profile() {

    const {state} = useContext(Context);
    useEffect(() => {
         console.log(state.user)
         }, []);

  return (
    <div>
        <SideBar></SideBar>
        <TopBaner></TopBaner>
        <div className='card'>
        <img src="/pycBlueIogo.png" alt="logo-pych" style={{height :'100px'}}/>
        <h3>הפרופיל שלי</h3>
        <img src={state.user?.photoURL} alt="User Profile" style={{ borderRadius: '50%', width: '60px', height: '60px' }} />
        <p>{state.user.displayName} : שם  </p>
        <p>{state.user.email} : אימייל  </p>
        </div>
        <Footer></Footer>
    </div>
  )
}

export default Profile